import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import TabNotationDisplay from './components/TabNotationDisplay';

// ─── Tab test page (//#tab-test) ─────────────────────────────────────────────
// First 4 notes of Twinkle in D, on violin strings (GDAE, 4 strings)
// D D A A — D string (str 3) and A string (str 2) open notes
// showTab defaults false for violin (no frets); notation only shown
const TWINKLE_4 = [
  { string: 3, fret: 0, beat: 1, noteName: 'D4' },
  { string: 3, fret: 0, beat: 2, noteName: 'D4' },
  { string: 2, fret: 0, beat: 3, noteName: 'A4' },
  { string: 2, fret: 0, beat: 4, noteName: 'A4' },
];

function TabTest() {
  const [active, setActive] = useState(null);
  return (
    <div style={{ minHeight:'100vh', background:'#0d0d1a', color:'#e2e8f0',
      fontFamily:"Georgia,serif", padding:'24px 16px' }}>
      <div style={{ maxWidth:480, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <div style={{ fontSize:36, marginBottom:8 }}>🎻</div>
          <h1 style={{ fontSize:18, fontWeight:800, marginBottom:4,
            background:'linear-gradient(135deg,#4a9eff,#7dd3fc,#1560bd)',
            WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            Notation Display — Test
          </h1>
          <p style={{ fontSize:11, color:'#6b7280' }}>
            Twinkle · 4 notes · violin GDAE · notation only (tab planned v1.2)
          </p>
        </div>

        {/* Notation only (violin default — no frets) */}
        <p style={{ fontSize:10, color:'#6b7280', textTransform:'uppercase',
          letterSpacing:'0.1em', marginBottom:6 }}>Notation (violin default)</p>
        <div style={{ background:'#1a1a2e', borderRadius:12, padding:'14px 10px',
          border:'1px solid rgba(74,158,255,0.2)', marginBottom:20 }}>
          <TabNotationDisplay notes={TWINKLE_4} currentNote={active} />
        </div>

        {/* Tab explicitly enabled (preview of v1.2) */}
        <p style={{ fontSize:10, color:'#6b7280', textTransform:'uppercase',
          letterSpacing:'0.1em', marginBottom:6 }}>Tab preview (showTab=true, v1.2)</p>
        <div style={{ background:'#1a1a2e', borderRadius:12, padding:'14px 10px',
          border:'1px solid rgba(74,158,255,0.2)', marginBottom:20 }}>
          <TabNotationDisplay notes={TWINKLE_4} showTab={true} currentNote={active} />
        </div>

        {/* Beat buttons */}
        <p style={{ fontSize:10, color:'#6b7280', textTransform:'uppercase',
          letterSpacing:'0.1em', marginBottom:8 }}>Tap to highlight</p>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:28 }}>
          {TWINKLE_4.map((n, i) => (
            <button key={i} onClick={() => setActive(active===i ? null : i)}
              style={{ padding:'8px 14px', borderRadius:10, cursor:'pointer',
                fontSize:12, fontWeight:700, fontFamily:'Georgia,serif',
                background: active===i ? 'rgba(74,158,255,0.2)' : 'rgba(21,96,189,0.1)',
                border:`1px solid ${active===i ? '#4a9eff' : 'rgba(74,158,255,0.3)'}`,
                color: active===i ? '#7dd3fc' : '#6b7280' }}>
              {n.noteName}
              <span style={{ display:'block', fontSize:9, opacity:0.7 }}>str.{n.string}</span>
            </button>
          ))}
        </div>

        <div style={{ textAlign:'center', paddingBottom:40 }}>
          <a href="#" style={{ color:'#6b7280', fontSize:12, textDecoration:'none' }}>
            ← Back to game
          </a>
        </div>
      </div>
    </div>
  );
}

// ─── Root with hash routing ──────────────────────────────────────────────────
function Root() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  if (hash === '#tab-test') return <TabTest />;
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')).render(<Root />);
